// Action Types
export const MY_ACTIONS_UPDATE_ACTIVE = 'MY_ACTIONS_UPDATE_ACTIVE';
export const MY_ACTIONS_CLEAR = 'MY_ACTIONS_CLEAR';

// Initial State
const initialState = {
  hasActiveMyActions: false,
  allActiveUsers: null,
};

// Reducer
export default function myActionsReducer(state = initialState, action) {
  switch (action.type) {
    case MY_ACTIONS_UPDATE_ACTIVE:
      return {
        ...state,
        hasActiveMyActions: action.hasActiveMyActions,
        allActiveUsers: action.allActiveUsers,
      };

    case MY_ACTIONS_CLEAR:
      return initialState;

    default:
      return state;
  }
}

// Action Creators
export const updateActiveMyActions = (hasActiveMyActions, allActiveUsers) => ({
  type: MY_ACTIONS_UPDATE_ACTIVE,
  hasActiveMyActions,
  allActiveUsers,
});

export const clearMyActions = () => ({
  type: MY_ACTIONS_CLEAR,
});
